import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import type { Company } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";
import { editCompany } from "../api/editCompany";

export const useEditCompany = (): UseMutationResult<ApiResponse, ApiError, Partial<Company>> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editCompany,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: withPrefix(["company"]) });
    },
  });
};
